import React from 'react';
import { Badge } from '../ui/badge';
import {
  CheckCircle, Clock, CloudArrowUp, ArrowsClockwise, XCircle, ArrowCounterClockwise,
  Hourglass, ShieldCheck, ThumbsDown,
} from '@phosphor-icons/react';
import { formatDate, formatDateTime } from '../../lib/utils';

const STATUS_CONFIG = {
  draft: { cls: 'bg-slate-100 text-slate-700 border-slate-200', icon: <Clock size={12} /> },
  pending_approval: { cls: 'bg-amber-50 text-amber-700 border-amber-300', icon: <Hourglass size={12} /> },
  approved: { cls: 'bg-teal-50 text-teal-700 border-teal-300', icon: <ShieldCheck size={12} /> },
  rejected_approval: { cls: 'bg-rose-50 text-rose-700 border-rose-300', icon: <ThumbsDown size={12} /> },
  ready: { cls: 'bg-blue-50 text-blue-700 border-blue-200', icon: <CloudArrowUp size={12} /> },
  submitted: { cls: 'bg-sky-50 text-sky-700 border-sky-200', icon: <ArrowsClockwise size={12} /> },
  accepted: { cls: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: <CheckCircle size={12} /> },
  failed: { cls: 'bg-red-50 text-red-700 border-red-200', icon: <XCircle size={12} /> },
  corrected: { cls: 'bg-violet-50 text-violet-700 border-violet-200', icon: <ArrowCounterClockwise size={12} /> },
};

const STATUS_LABELS = {
  pending_approval: 'Pending Approval',
  rejected_approval: 'Rejected',
  approved: 'Approved',
};

export const getEvvStatusBadge = (status) => {
  const key = status || 'draft';
  const cfg = STATUS_CONFIG[key] || STATUS_CONFIG.draft;
  const label = STATUS_LABELS[key] || (key.charAt(0).toUpperCase() + key.slice(1));
  return (
    <Badge variant="outline" className={cfg.cls}>
      <span className="flex items-center gap-1">{cfg.icon}{label}</span>
    </Badge>
  );
};

export const fmtDate = (d) => formatDate(d);

export const fmtTime = (t) => {
  if (!t) return '-';
  if (t.includes(':')) {
    const [h, m] = t.split(':');
    const hr = parseInt(h, 10);
    const ampm = hr >= 12 ? 'PM' : 'AM';
    return `${hr % 12 || 12}:${m} ${ampm}`;
  }
  return t;
};

export const fmtDatetime = (iso) => formatDateTime(iso);
